/* discount-price.js – 20 % CAD FLASH SALE, flicker-free on Subscribe toggle */
document.addEventListener('DOMContentLoaded', () => {

  /* settings ----------------------------------------------------- */
  const DISCOUNT  = 0.20;          // 20 %
  const CURRENCY  = 'CAD';
  const EXTRA     = ' 💥 THANKSGIVING SALE 💥';
  const SELECTOR  = '.price';      // any element that shows a price
  /* -------------------------------------------------------------- */

  const fmt = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: CURRENCY,
    minimumFractionDigits: 2
  });

  /* create—or get—the promo span that follows el */
  function promoSpan(el) {
    if (el.nextElementSibling?.classList.contains('discount-display')) {
      return el.nextElementSibling;
    }
    const span = document.createElement('span');
    span.className = 'discount-display';
    el.after(span);
    return span;
  }

  function update(el) {
    const match = el.textContent.match(/[\d.,]+/);   // read hidden raw price
    if (!match) return;

    const base = parseFloat(match[0].replace(/,/g, ''));
    if (isNaN(base)) return;

    /* Skip if promo already shows this exact value */
    const wrapper = promoSpan(el);
    if (Number(wrapper.dataset.lastBase) === base) return;
    wrapper.dataset.lastBase = base;

    wrapper.innerHTML =
      `<span style="text-decoration:line-through;opacity:.7;margin-right:.25em">${fmt.format(base)}</span>` +
      `<span style="font-weight:700;color:#e60000">${fmt.format(base * (1 - DISCOUNT))}<br>${EXTRA}</span>`;

    /* keep ReCharge’s span hidden so its repaints never flash */
    el.style.display = 'none';
  }

  /* scan any subtree once */
  function scan(root = document) {
    root.querySelectorAll(SELECTOR).forEach(update);
  }

  /* first pass */
  scan();

  /* observe: whenever new nodes arrive or price text changes */
  new MutationObserver(muts => {
    muts.forEach(m => {
      if (m.type === 'childList') {
        m.addedNodes.forEach(n => {
          if (n.nodeType === 1 && n.matches?.(SELECTOR)) update(n);
          else if (n.nodeType === 1) n.querySelectorAll?.(SELECTOR).forEach(update);
        });
      } else if (m.type === 'characterData') {
        const p = m.target.parentElement;
        if (p && p.matches(SELECTOR)) update(p);
      }
    });
  }).observe(document.body, { subtree: true, childList: true, characterData: true });
});
